export const updateSearchTermsForUnmatchedCard = (card) => {
  let q = []
  if (card?.set) {
    q.push(card.set)
  } else if (card?.brand) {
    q.push(card.brand)
  }

  if (card?.subset) {
    q.push(card.subset)
  }

  if (card?.card_number) {
    q.push(`#${card.card_number}`)
  }

  if (card?.player) {
    q.push(card.player)
  }

  if (card?.attributes) {
    q.push(card.attributes)
  }

  return {
    searchTermForUnmatchedCard_: q.join(' '),
    searchTerms_: q.join(' ')
  }
}

export const getLockSetQueryKey = (batchStore) => {
  let lockSetQueryKey = 'baseSetIds'

  if (batchStore.selectedBatch?.lock_id && batchStore.selectedBatch?.lock_includes_parallels) {
    lockSetQueryKey = 'baseSetIds'
  } else if (batchStore.selectedBatch?.lock_id && !batchStore.selectedBatch?.lock_includes_parallels) {
    lockSetQueryKey = 'setIds'
  }

  return lockSetQueryKey
}

export const getParamsBasedOnLockedSets = (lockedSets = []) => {
  let baseSetIds = ''
  let setIds = ''

  lockedSets?.forEach((item) => {
    if (item.include_parallels) {
      if (baseSetIds) {
        baseSetIds = `${baseSetIds},${item.collx_set_id}`
      } else {
        baseSetIds = `${item.collx_set_id}`
      }
    } else {
      if (setIds) {
        setIds = `${setIds},${item.collx_set_id}`
      } else {
        setIds = `${item.collx_set_id}`
      }
    }
  })

  const params = {}

  if (baseSetIds) {
    params['baseSetIds'] = baseSetIds
  } 

  if (setIds) {
    params['setIds'] = setIds
  }

  return params
}